import React from 'react'
import PropTypes from 'prop-types'
import CtaButton from 'components/cta-button'
import Font from '@cred/react-font'
import styles from './styles.scss'

const Footer = ({ update, cancel, invalid }) => {
  const submit = () => {
    if (invalid) {
      return
    }

    update()
  }

  return (
    <>
      {/* Buffer element to prevent form from overflowing footer since footer is absolutely positioned at the bottom of the page */}
      <div className={styles.buffer} />
      <div className={styles.root}>
        <CtaButton
          small
          primary
          onClick={submit}
          disabled={invalid}
        >Update
        </CtaButton>
        <Font
          type="bodySmall"
          className={styles['close-button']}
          element="button"
          onClick={cancel}
        >Close
        </Font>
      </div>
    </>
  )
}

Footer.propTypes = {
  cancel: PropTypes.func,
  update: PropTypes.func,
  invalid: PropTypes.bool,
}

export { Footer as FooterNoHoc }

export default Footer
// export default withStyles(defaultStyles, { fox1 })(Footer)
